import React from 'react';
import { Mail } from 'lucide-react';
import '../styles/projectsoftpower.css';
import '../styles/cultural-platform.css';

const TeamUpdated = () => {
  const imdbIcon = "https://customer-assets.emergentagent.com/job_soft-influence-1/artifacts/5jsufwyl_vecteezy_imdb-logo-transparent-background_49116727.png";
  const grokipediaIcon = "https://customer-assets.emergentagent.com/job_soft-influence-1/artifacts/9pee35yc_grok.png";
  const instagramIcon = "https://customer-assets.emergentagent.com/job_soft-influence-1/artifacts/g2at6nre_vecteezy_instagram-logo-png-instagram-icon-transparent_18930415.png";

  const nishaPhoto = "https://customer-assets.emergentagent.com/job_45a5a819-d501-49e3-92bf-1c1872263581/artifacts/lx65425t_NISHA%20LEE%20MARTY%20COO-2.jpg";

  return (
    <div className="team-page" data-testid="leadership-page">
      {/* Hero Section */}
      <section className="section-spacing-large" style={{
        background: 'linear-gradient(135deg, var(--color-gray-50) 0%, var(--color-white) 100%)',
        textAlign: 'center'
      }}>
        <div className="container-psp">
          <h1 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(32px, 4vw, 48px)',
            fontWeight: '400',
            color: '#202124',
            marginBottom: '16px'
          }}>
            Leadership
          </h1>
          <p style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: 'clamp(16px, 2vw, 18px)',
            color: '#5F6368',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            The people behind Project Soft Power
          </p>
        </div>
      </section>

      {/* Founder & Head - Leander Lee Marty */}
      <section className="section-spacing-large" style={{ background: 'var(--color-white)' }}>
        <div className="container-psp">
          <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '48px',
              alignItems: 'flex-start'
            }}>
              <div style={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_bb736b37-09cb-4465-9b20-ce9e662fa067/artifacts/vz3zs163_Copy%20of%20LEANDER%20LEE%20MARTY%20ON%20BOARD%20POSTER.png.PNG"
                  alt="Leander Lee Marty"
                  data-testid="leander-photo"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
              <div>
                <h2 style={{
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: 'clamp(28px, 3vw, 36px)',
                  fontWeight: '400',
                  color: '#202124',
                  marginBottom: '8px'
                }}>
                  Leander Lee Marty
                </h2>
                <div style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#1A73E8',
                  marginBottom: '4px'
                }}>
                  Founder & Head
                </div>
                <div style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  color: '#5F6368',
                  marginBottom: '24px',
                  fontStyle: 'italic'
                }}>
                  Filmmaker | Composer | Producer | Cultural Strategist
                </div>

                <div style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '15px',
                  lineHeight: '1.8',
                  color: '#202124',
                  marginBottom: '16px'
                }}>
                  <p style={{ marginBottom: '16px' }}>
                    Leander Lee Marty is an internationally active Director, Composer, Producer, and Cultural Strategist working across the Indian film industry and Southeast Asian creative ecosystems. With over fifteen years of experience in arts, cinema, music, and cultural development, his work reflects a deep commitment to using creative expression as a force for unity, dignity, and sustainable progress.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    His professional journey began in the cultural departments of schools and colleges, where he nurtured young talent and developed community-based creative programs. Parallel to this, he collaborated extensively with NGOs and cultural institutions, traveling across India, Indonesia, Singapore, and Malaysia to support grassroots arts and cultural initiatives.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    Over the years, Leander has built a distinguished career in cinema and music, contributing to box office successes and earning multiple awards for his creative work. His path has been built from the ground up—guided by discipline, lived experience, and a strong sense of service.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    Drawing from this cumulative experience, Leander founded Project Soft Power—an independent international arts, films, and cultural development initiative based in Singapore, India, and the UAE. Conceived as a long-term cultural framework rather than a commercial venture, Project Soft Power positions creative expression as constructive soft power—strengthening positive national identity, enabling international dialogue, and supporting sustainable cultural and economic development.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    At its core, Project Soft Power reflects the values of the United Nations and advances the Sustainable Development Goals through people-centered, creative initiatives. The organization promotes truthful, balanced, and dignified storytelling, recognizing cinema and the arts as vital tools for cultural diversity, heritage preservation, and intercultural understanding.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    Under Leander's leadership, the initiative has gained international recognition and institutional engagement. Its proposals have been positively received by the National Arts Council and MediaCorp Singapore, collaborations are underway with the Egypt Film Commission, and strategic dialogues are ongoing with leading cultural authorities in Abu Dhabi.
                  </p>
                  <p>
                    Through Project Soft Power, Leander Lee Marty continues to work toward a world where arts, films, and culture unite nations—not through propaganda, but through authenticity, respect, and human-centered storytelling.
                  </p>
                </div>

                {/* Contact and Social Links */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  flexWrap: 'wrap',
                  marginTop: '24px'
                }}>
                  <a
                    href="mailto:leanderleemarty@projectsoftpower.org"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '12px 24px',
                      background: '#1A73E8',
                      color: '#FFFFFF',
                      borderRadius: '4px',
                      textDecoration: 'none',
                      fontFamily: 'Google Sans, Roboto, sans-serif',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'background 0.2s ease'
                    }}
                    data-testid="leander-contact-btn"
                    onMouseEnter={(e) => e.target.style.background = '#1557B0'}
                    onMouseLeave={(e) => e.target.style.background = '#1A73E8'}
                  >
                    <Mail size={18} />
                    Contact
                  </a>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <a
                      href="https://www.imdb.com/name/nm13691372/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="IMDb Profile"
                      data-testid="imdb-link"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '44px',
                        height: '44px',
                        borderRadius: '8px',
                        background: '#F1F3F4',
                        transition: 'all 0.2s ease',
                        textDecoration: 'none',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#E8F0FE';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F1F3F4';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <img src={imdbIcon} alt="IMDb" style={{ height: '28px', width: 'auto', objectFit: 'contain', pointerEvents: 'none' }} />
                    </a>

                    <a
                      href="https://grokipedia.com/page/Leander_Lee_Marty"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Grokipedia Profile"
                      data-testid="grokipedia-link"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '44px',
                        height: '44px',
                        borderRadius: '8px',
                        background: '#F1F3F4',
                        transition: 'all 0.2s ease',
                        textDecoration: 'none',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#E8F0FE';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F1F3F4';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <img src={grokipediaIcon} alt="Grokipedia" style={{ height: '28px', width: 'auto', objectFit: 'contain', pointerEvents: 'none' }} />
                    </a>

                    <a
                      href="https://www.instagram.com/leanderleemarty"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram Profile"
                      data-testid="instagram-link"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '44px',
                        height: '44px',
                        borderRadius: '8px',
                        background: '#F1F3F4',
                        transition: 'all 0.2s ease',
                        textDecoration: 'none',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#E8F0FE';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F1F3F4';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <img src={instagramIcon} alt="Instagram" style={{ height: '28px', width: 'auto', objectFit: 'contain', pointerEvents: 'none' }} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 24px' }}>
        <hr style={{ border: 'none', borderTop: '1px solid #E8EAED', margin: 0 }} />
      </div>

      {/* COO - Nisha Lee Marty */}
      <section className="section-spacing-large" style={{ background: 'var(--color-white)' }}>
        <div className="container-psp">
          <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '48px',
              alignItems: 'flex-start'
            }}>
              <div style={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}>
                <img
                  src={nishaPhoto}
                  alt="Nisha Lee Marty"
                  data-testid="nisha-photo"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
              <div>
                <h2 style={{
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: 'clamp(28px, 3vw, 36px)',
                  fontWeight: '400',
                  color: '#202124',
                  marginBottom: '8px'
                }}>
                  Nisha Lee Marty
                </h2>
                <div style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#1A73E8',
                  marginBottom: '4px'
                }}>
                  Chief Operating Officer (COO)
                </div>
                <div style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  color: '#5F6368',
                  marginBottom: '24px',
                  fontStyle: 'italic'
                }}>
                  Executive Film Producer | Writer | Cultural Strategist
                </div>

                <div style={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '15px',
                  lineHeight: '1.8',
                  color: '#202124',
                  marginBottom: '16px'
                }}>
                  <p style={{ marginBottom: '16px' }}>
                    Nisha Lee Marty is the Chief Operating Officer (COO) of Project Soft Power, an independent global initiative dedicated to arts, film, culture, and creative diplomacy.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    Born in Pondicherry, India, and raised in Singapore, Nisha brings a distinctly transnational perspective shaped by deep exposure to Southeast Asia, South Asia, and the Middle East. Her professional journey spans Singapore, India, Malaysia, Indonesia, and ongoing cultural engagements across the UAE and Egypt.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    With a strong foundation in the media, film, and creative industries, Nisha has worked extensively as an Executive Film Producer within the Indian film industry and across Southeast Asian creative ecosystems. Her experience includes active involvement in projects with MediaCorp and collaborative work across regional film and media platforms in Singapore, Indonesia, and Malaysia.
                  </p>
                  <p style={{ marginBottom: '16px' }}>
                    A writer and cultural thinker, she is the author of the book <em>Extinct Woman</em>, which reflects her engagement with identity, contemporary society, and creative expression. From an early age, she has also been involved in cultural initiatives and dialogues alongside cultural and local government institutions in Singapore, contributing to policy-adjacent arts and youth-driven cultural frameworks.
                  </p>
                  <p>
                    At Project Soft Power, Nisha plays a pivotal operational and strategic role—overseeing international collaborations, institutional partnerships, and cross-border cultural initiatives. Her lived experience across multiple regions, combined with her leadership in film, media, and cultural development, enables her to drive the organization's mission with clarity, discipline, and global sensitivity.
                  </p>
                </div>

                {/* Contact and Social Links */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  flexWrap: 'wrap',
                  marginTop: '24px'
                }}>
                  <a
                    href="mailto:nishaleemarty@projectsoftpower.org"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '12px 24px',
                      background: '#1A73E8',
                      color: '#FFFFFF',
                      borderRadius: '4px',
                      textDecoration: 'none',
                      fontFamily: 'Google Sans, Roboto, sans-serif',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'background 0.2s ease'
                    }}
                    data-testid="nisha-contact-btn"
                    onMouseEnter={(e) => e.target.style.background = '#1557B0'}
                    onMouseLeave={(e) => e.target.style.background = '#1A73E8'}
                  >
                    <Mail size={18} />
                    Contact
                  </a>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <a
                      href="https://www.instagram.com/nishaleemarty/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram Profile"
                      data-testid="nisha-instagram-link"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '44px',
                        height: '44px',
                        borderRadius: '8px',
                        background: '#F1F3F4',
                        transition: 'all 0.2s ease',
                        textDecoration: 'none',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#E8F0FE';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F1F3F4';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <img src={instagramIcon} alt="Instagram" style={{ height: '28px', width: 'auto', objectFit: 'contain', pointerEvents: 'none' }} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 24px' }}>
        <hr style={{ border: 'none', borderTop: '1px solid #E8EAED', margin: 0 }} />
      </div>

      {/* Chairman - Chandra Shankar */}
      <section className="section-spacing-large" style={{ background: 'var(--color-white)' }}>
        <div className="container-psp">
          <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '48px',
              alignItems: 'flex-start'
            }}>
              <div style={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_45a5a819-d501-49e3-92bf-1c1872263581/artifacts/9ux3qb7s_CHANDRA%20SHANKAR%20CHAIRMAN.jpg"
                  alt="Chandra Shankar"
                  data-testid="chairman-photo"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
              <div>
            <h2 style={{
              fontFamily: 'Google Sans, Roboto, sans-serif',
              fontSize: 'clamp(28px, 3vw, 36px)',
              fontWeight: '400',
              color: '#202124',
              marginBottom: '8px'
            }}>
              Chandra Shankar
            </h2>
            <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '16px',
              fontWeight: '700',
              color: '#1A73E8',
              marginBottom: '4px'
            }}>
              Chairman
            </div>
            <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#5F6368',
              marginBottom: '24px',
              fontStyle: 'italic'
            }}>
              Yard Manager - Singatac Engineering Pte Ltd, Singapore / Indonesia
            </div>

            <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '15px',
              lineHeight: '1.8',
              color: '#202124',
              marginBottom: '16px'
            }}>
              <p style={{ marginBottom: '16px' }}>
                Chandra Shankar serves as the Chairman of Project Soft Power, providing strategic leadership, institutional guidance, and long-term vision to the organization's global cultural mission.
              </p>
              <p style={{ marginBottom: '16px' }}>
                Based in Singapore, with extensive operations across Indonesia and Malaysia, Shankar is an accomplished entrepreneur and industry leader with over three decades of experience spanning marine oil and gas, media, and the film industry. He is the founder and owner of a marine oil and gas enterprise operating across Southeast Asia, alongside a distinguished career as a film producer in the Indian film industry.
              </p>
              <p style={{ marginBottom: '16px' }}>
                With more than 30 years of involvement in cinema and media, Shankar possesses exceptional insight into the creative, financial, and cultural dimensions of filmmaking. His work as a producer and industry veteran has given him a deep understanding of how stories, cultures, and industries intersect across borders—making him a vital bridge between business, culture, and creative diplomacy.
              </p>
              <p style={{ marginBottom: '16px' }}>
                Having travelled extensively across the world, Shankar brings a nuanced understanding of cultural diversity, regional sensibilities, and global storytelling practices. His exposure to different film traditions, production ecosystems, and cultural frameworks enables him to guide Project Soft Power with global awareness and ethical clarity.
              </p>
              <p style={{ marginBottom: '16px' }}>
                As Chairman and Chief Advisor, Chandra Shankar plays a senior-most role in aligning Project Soft Power's vision, values, and long-term objectives. He actively supports the leadership team by nurturing talent, strengthening institutional ethics, and ensuring that the organization remains anchored to its core principles of cultural respect, collaboration, and integrity.
              </p>
              <p>
                His depth of experience in business, media, and international engagement makes Chandra Shankar a foundational pillar of Project Soft Power—guiding the initiative with wisdom, discipline, and a commitment to sustainable cultural impact.
              </p>
            </div>

            {/* Contact */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexWrap: 'wrap',
              marginTop: '24px'
            }}>
              <a
                href="mailto:chandrashankar@projectsoftpower.org"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 24px',
                  background: '#1A73E8',
                  color: '#FFFFFF',
                  borderRadius: '4px',
                  textDecoration: 'none',
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'background 0.2s ease'
                }}
                data-testid="chairman-contact-btn"
                onMouseEnter={(e) => e.target.style.background = '#1557B0'}
                onMouseLeave={(e) => e.target.style.background = '#1A73E8'}
              >
                <Mail size={18} />
                Contact
              </a>
            </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Notes Section */}
      <section style={{
        background: 'linear-gradient(135deg, #F8F9FA 0%, #FFFFFF 100%)',
        padding: 'clamp(48px, 6vw, 96px) 24px'
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h2 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(28px, 3.5vw, 40px)',
            fontWeight: '400',
            color: '#202124',
            textAlign: 'center',
            marginBottom: '64px'
          }} data-testid="leadership-notes-heading">
            Leadership Notes
          </h2>

          {/* Founder's Note */}
          <div style={{
            marginBottom: '56px',
            padding: '40px',
            background: '#FFFFFF',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            borderLeft: '4px solid #1A73E8'
          }} data-testid="founder-note">
            <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '12px',
              fontWeight: '600',
              color: '#1A73E8',
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              marginBottom: '16px'
            }}>
              Founder & Head's Note
            </div>
            <h3 style={{
              fontFamily: 'Google Sans, Roboto, sans-serif',
              fontSize: '22px',
              fontWeight: '400',
              color: '#202124',
              marginBottom: '20px'
            }}>
              Leander Lee Marty
            </h3>
            <blockquote style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '16px',
              lineHeight: '1.9',
              color: '#3C4043',
              fontStyle: 'italic',
              margin: 0,
              padding: 0
            }}>
              &#8220;Project Soft Power was founded with love, belief, and responsibility—rooted in the idea that arts and culture can unite nations beyond borders. This initiative is a platform for global connection, where creativity becomes dialogue and empathy becomes influence. Our vision is to build a trusted international cultural ecosystem that complements global institutions and nurtures shared human values. At its heart, Project Soft Power exists to remind the world that culture is our most enduring common language.&#8221;
            </blockquote>
          </div>

          {/* COO's Note */}
          <div style={{
            marginBottom: '56px',
            padding: '40px',
            background: '#FFFFFF',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            borderLeft: '4px solid #1A73E8'
          }} data-testid="coo-note">
            <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '12px',
              fontWeight: '600',
              color: '#1A73E8',
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              marginBottom: '16px'
            }}>
              Chief Operating Officer's Note
            </div>
            <h3 style={{
              fontFamily: 'Google Sans, Roboto, sans-serif',
              fontSize: '22px',
              fontWeight: '400',
              color: '#202124',
              marginBottom: '20px'
            }}>
              Nisha Lee Marty
            </h3>
            <blockquote style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '16px',
              lineHeight: '1.9',
              color: '#3C4043',
              fontStyle: 'italic',
              margin: 0,
              padding: 0
            }}>
              &#8220;Project Soft Power stands on clarity, discipline, and collective strength. As COO, my focus is on building efficient systems, meaningful partnerships, and ethical operations that allow creative vision to translate into real-world impact. Every process is designed to respect diversity while maintaining professionalism and accountability. Our responsibility is to ensure that purpose is supported by structure—and that vision is sustained through action.&#8221;
            </blockquote>
          </div>

          {/* Chairman's Note */}
          <div style={{
            padding: '40px',
            background: '#FFFFFF',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            borderLeft: '4px solid #1A73E8'
          }} data-testid="chairman-note">
            <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '12px',
              fontWeight: '600',
              color: '#1A73E8',
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              marginBottom: '16px'
            }}>
              Chairman's Note
            </div>
            <h3 style={{
              fontFamily: 'Google Sans, Roboto, sans-serif',
              fontSize: '22px',
              fontWeight: '400',
              color: '#202124',
              marginBottom: '20px'
            }}>
              Chandra Shankar
            </h3>
            <blockquote style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '16px',
              lineHeight: '1.9',
              color: '#3C4043',
              fontStyle: 'italic',
              margin: 0,
              padding: 0
            }}>
              &#8220;Project Soft Power is guided by values, resilience, and long-term thinking. As Chairman, my role is to nurture the team, protect the core ethics of the initiative, and encourage perseverance through every challenge. Cultural work demands patience, integrity, and heart—and these must never be compromised. I stand with the team to ensure that purpose remains strong, and the journey continues with confidence and conviction.&#8221;
            </blockquote>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamUpdated;
